import { render, staticRenderFns } from "./TemplateAddEdit.vue?vue&type=template&id=a8462378&"
import script from "./TemplateAddEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAddEdit.vue?vue&type=style&index=0&id=a8462378&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports